// extracted by mini-css-extract-plugin
export default {"root":"ZUpwvR_4Xmse6h0zqJXT"};